// src/index.ts
import { createTransform } from "redux-persist";
var transformExpire = (expireIn, expireKey = "persistencyExpiration", defaultValue = {}) => {
  let storedExpiration;
  try {
    storedExpiration = localStorage.getItem(expireKey);
  } catch (e) {
  }
  let expired = false;
  if (storedExpiration) {
    const expiring = parseInt(storedExpiration);
    const now = (/* @__PURE__ */ new Date()).getTime();
    expired = Boolean(expiring) && !isNaN(expiring) && now > expiring;
  }
  return createTransform(
    (inboundState) => {
      setTimeout(() => {
        const expireValue = ((/* @__PURE__ */ new Date()).getTime() + expireIn).toString();
        try {
          localStorage.setItem(expireKey, expireValue);
        } catch (e) {
        }
      }, 0);
      return inboundState;
    },
    (outboundState) => expired ? defaultValue : outboundState
  );
};
var src_default = transformExpire;
export {
  src_default as default
};
